export default "__VITE_ASSET__ZHFOy4nj__"